<template>
  <a-tag
    v-if="tag.label"
    :color="tag.color"
    :class="`availability-label--${tag.type}`"
    class="availability-label"
  >
    {{ tag.label }}
  </a-tag>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    tag() {
      const statusTagMap = {
        confirmed: {
          color: 'cyan',
          type: 'confirmed',
          label: 'Zatwierdzona'
        },
        pending: {
          color: 'default',
          type: 'pending',
          label: 'Oczekuje na zatwierdzenie'
        }
      }

      return statusTagMap[this.type] || {}
    }
  }
}
</script>

<style lang="scss" scoped>
.availability-label {
  &--pending {
    background-color: white;
    color: #5cdbd3;
    border-color: #b5f5ec;
  }
}
</style>
